import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ borderLess?: boolean }>()(
  (theme, { borderLess }) => ({
    updateRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(3),
    },
    closeIconButton: {
      marginBottom: theme.spacing(2),
    },
    recipientsRowsContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    subTitle: {
      color: theme.palette.labraText.primary,
      fontWeight: 500,
      fontSize: '16px',
      width: '98%',
    },
    recipientTitleWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    deleteWrapper: {
      width: '2%',
      justifyContent: 'end',
    },
    addRecipientBtn: {
      color: theme.palette.select.light,
      cursor: 'pointer',
      fontWeight: 500,
      width: 'fit-content',
      marginTop: theme.spacing(2),
      ...(borderLess ? { paddingTop: theme.spacing(3) } : {}),
    },
    borderRecipient: {
      borderRadius: '4px',
      padding: !borderLess ? theme.spacing(4, 4, 2.5, 4) : theme.spacing(5, 0),
      marginBottom: theme.spacing(3),
      ...(!borderLess
        ? { border: `1px solid ${theme.palette.dividerV2.main}` }
        : {
            borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
            marginBottom: 0,
          }),
    },
    lastRecipient: {
      border: 'none !important',
      paddingBottom: `${theme.spacing(0)} !important`,
    },
    firstRecipient: {
      paddingTop: `${theme.spacing(0)} !important`,
    },
    recipientWidth: {
      width: 'calc(98% - 24px)',
    },
    removeIconPadding: {
      padding: theme.spacing(0),
    },
  })
)
